



















import Vue from 'vue'
import { Component, Config } from '@niknevis/vue-modules'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import MenuItem from '@/modules/common/layout/components/shared/menu/MenuItem.vue'
import { MenuItemType } from '@/modules/common/layout/models/types/MenuItem'


const __predicateMenuItem = (item: MenuItemType) => {
  return (window.location.pathname + window.location.search).match(new RegExp(item?.regex))
}


const __predicateMenu = (menu: MenuItemType) => menu?.children?.find(__predicateMenuItem)

@Component({
  components: {
    MenuItem
  }
})
export default class MenuItems extends Vue {
  @Prop() mini!: boolean
  @Prop() items!: Array<MenuItemType>
  itemId = ''
  public userType: string = Config.get('userType')

  dynamicHover: boolean = false

  @Watch('items', { immediate: true })
  itemsWatcher(newValue) {
    this.itemId = newValue.find(__predicateMenu)?.children?.findLast(__predicateMenuItem)?.id ||
      newValue.findLast(__predicateMenuItem).id || ''
  }

  get listClasses() {
    const classes = ['full-width']

    return classes.concat(this.isLight ? ['panel-menu'] : ['admin-menu'])
  }

  setDynamicHover(value: boolean) {
    this.dynamicHover = value
  }

  @Emit('close')
  onChange(iid) {
    this.itemId = iid
  }

  get isLight() {
    return this.userType === 'panel'
  }
}
